import React from "react";

function HeroSmall({ bg, title, subtitle }) {
  return (
    <div
      className="relative h-56 overflow-hidden bg-cover bg-center bg-no-repeat md:h-72"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/60 to-black/75" />
      <div className="relative z-10 flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
        <h1 className="font-heading text-3xl font-bold text-main-light sm:text-4xl md:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="max-w-xl font-copy text-base text-main-light/80 md:text-lg">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}

export default HeroSmall;
